module.exports = __webpack_public_path__ + "static/img/信息框1@2x.865b4b75.png";